import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";
import {getHeader} from "../../../_fri/utils/function";
import {
    StatusSaleInProgressQrRequest,
    StatusSaleInProgressQrResponse,
    SaleInProgressQrRequest,
    SaleInProgressQrResponse, CancelSaleInProgressQrResponse, CancelSaleInProgressQrRequest
} from "../interface/current";

export const current = createApi({

        reducerPath: "current",
        baseQuery: fetchBaseQuery({
            baseUrl: `${process.env.REACT_APP_API_URL}/business/processors/v2/orders/current/`,
            prepareHeaders: (headers, {getState}) => {
                return getHeader(headers, getState);
            },
        }),
        endpoints: (builder) => ({
            createSale: builder.mutation<SaleInProgressQrResponse, SaleInProgressQrRequest>({
                query: (data) => ({
                    url: `create`,
                    method: "Post",
                    body: data,
                }),
            }),
            statusSale: builder.query<StatusSaleInProgressQrResponse, StatusSaleInProgressQrRequest>({
                query: (data) => ({
                    url: `get-active`,
                    method: "Post",
                    body: data,
                }),
            }),
            cancelSale: builder.mutation<CancelSaleInProgressQrResponse, CancelSaleInProgressQrRequest>({
                query: (data) => ({
                    url: `cancel`,
                    method: "DELETE",
                    body: data,
                }),
            }),
        }),
    })
;
export const {
    useCreateSaleMutation,
    useStatusSaleQuery,
    useCancelSaleMutation
} = current;
